import { render, staticRenderFns } from "./ImgIcon.vue?vue&type=template&id=9c4d2a26&"
import script from "./ImgIcon.vue?vue&type=script&lang=js&"
export * from "./ImgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports